export const apiBaseEndpoint = process.env.NODE_ENV === "development" ? "http://localhost" : "https://api.kzv.si"
